import React from 'react'

// A PrimeReact outlined button that is a real link opening in a new tab (so the layout stays open here).
export default function NewTabLink ({ label, href, ...rest }) {
  return (
    <a className='p-button p-component p-button-outlined' href={href} target='_blank' rel='noopener noreferrer' {...rest}>
      <span className='p-button-icon p-c p-button-icon-left pi pi-external-link' aria-hidden='true' />
      <span className='p-button-label p-c'>{label}</span>
    </a>
  )
}
